import React, { useEffect } from 'react';

import { Col, Container, Row } from 'reactstrap'
import { P } from '../AbstractElements'
export default function Footer() {
    const currentYear = new Date().getFullYear();
    useEffect(() => {
        const script1 = document.createElement('script');
        script1.src = 'https://widgets.leadconnectorhq.com/loader.js';
        script1.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
        script1.setAttribute('data-widget-id', '6755fe767dc877e62db6a6c8');
        document.body.appendChild(script1);

        const script2 = document.createElement('script');
        script2.src = 'https://widgets.leadconnectorhq.com/loader.js';
        script2.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
        document.body.appendChild(script2);

        return () => {
            document.body.removeChild(script1);
            document.body.removeChild(script2);
        };
    }, []);
    return (
        <footer className="footer">
            <Container fluid>
                <Row>
                    <Col md={6} className="footer-copyright">
                        <P className="mb-0">{`Copyright ${currentYear} © Fintrack.`}</P>
                    </Col>
                </Row>
            
            </Container>
              
        </footer>
    )
}
